import {startDigitsSO} from './index';

export const testUsersCard = [
  `${startDigitsSO}012000475687`,
  `${startDigitsSO}012000475679`,
  `${startDigitsSO}842001309174`,
  `${startDigitsSO}862001309156`,
  `${startDigitsSO}692001309165`,
  `${startDigitsSO}012000475224`,
  `${startDigitsSO}902003359021`,
  `${startDigitsSO}992003359097`,
  `${startDigitsSO}012003730308`,
  `${startDigitsSO}012003720208`,
  //Murmansk:
  '5121112220020404', //non-financial
  '5121332220020400', // financial
  '5121760699990091',
  '5121000000000054',
  '5121191499995066',
  '5123600899990137',
  '5123759099995260',
];

export const testUsersPhone = [
  '9772344444',
  '9234445577',
  '9234445566',
  '9231112233',
  '9234445544',
  '9234446666',
  '9345545566',
  '9217776661',
  '9217776662',
  //Murmansk:
  '9310171775',
  '9072300444',
  '9936772083',
  '9545444323',
  '9658676766',
  '9510492533',
  '9456563333',
  ////// 8
  '89772344444',
  '89234445577',
  '89234445566',
  '89231112233',
  '89234445544',
  '89234446666',
  '89345545566',
  '89217776661',
  '89217776662',
  //Murmansk:
  '89310171775',
  '89072300444',
  '89936772083',
  '89545444323',
  '89658676766',
  '89510492533',
  '89456563333',
  ////// +7
  '+79772344444',
  '+79234445577',
  '+79234445566',
  '+79231112233',
  '+79234445544',
  '+79234446666',
  '+79345545566',
  '+79217776661',
  '+79217776662',
  //Murmansk:
  '+79310171775',
  '+79072300444',
  '+79936772083',
  '+79545444323',
  '+79658676766',
  '+79456563333',
  '+79510492533',
  ////// 7
  '79772344444',
  '79234445577',
  '79234445566',
  '79231112233',
  '79234445544',
  '79234446666',
  '79345545566',
  '79217776661',
  '79217776662',
  //Murmansk:
  '79310171775',
  '79072300444',
  '79936772083',
  '79545444323',
  '79658676766',
  '79510492533',
  '79456563333',
];

export const testUserSnils = [
  '11775475180',
  '32250556336',
  '89270215726',
  '53024753958',
  '50640631348',
  '10988758522',
  '44396480718',
  '89596094904',
  '34657995946',
  '99569158809',
  //Murmansk:
  '76855606662',
  '48404938108',
  '64828204614',
  '18215498177',
  '12048651736',
  '98491219665',
  '24818822295',
];

// Test password: asdf1234
